import { frontendURL } from 'dashboard/helper/URLHelper';
import RetentionOperations from './pages/RetentionOperations.vue';

const retentionRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/retention'),
      name: 'retention_operations',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: RetentionOperations,
    },
  ],
};

export default retentionRoutes;
